// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3APNP","subheader":"ReorderModal_subheader__1beMk","listWrap":"ReorderModal_listWrap__21cVA"};